import { Product } from "@greeter/core";

export const mockProduct: Product = {
  id: "asdf",
  title: "asdf",
  subTitle: "asdf",
  price: 100,
  priority: 0,
  description: "asdf",
  coverAsset: {
    id: "",
    name: "",
    root: "",
    path: "",
    uri: "",
    sizes: [],
  },
  coverUrl: "asdf",
  categories: [],
  discountStrategy: "Percentage",
  discountFixed: 0,
  discountPercentage: 0,
};
